import qs from 'qs'

import api from '@/services/base.service'

const methods = {
  getPedidos(
    bodegaId,
    estados = [],
    tiposPedido = [1, 2, 3, 4, 5],
    zonaId = -1,
    soloHoy = false,
    tiposEntrega = [-1],
    pageSize = 30,
    soloProgramado = false
  ) {
    return api.get(`/pedidos`, {
      params: {
        bodegaId,
        estados,
        tiposPedido,
        zonaId,
        soloHoy,
        tiposEntrega,
        soloProgramado,
        pageSize
      },
      paramsSerializer: (params) => qs.stringify(params)
    })
  },
  getPedidosByZona(zonaId, estados = [], soloHoy = false, pageSize = 30) {
    return api.get(`/pedidos/zona/${zonaId}`, {
      params: {
        estados,
        soloHoy,
        pageSize
      },
      paramsSerializer: (params) => qs.stringify(params)
    })
  },
  getPedidosCliente(bodegaId) {
    return api.get(`/pedidos-cliente`, {
      params: { bodegaId },
      paramsSerializer: (params) => qs.stringify(params)
    })
  },
  getPedidoByParams(params) {
    return api.get(`/pedidos/parametros`, { params })
  },
  getPedido(id) {
    return api.get(`/pedidos/${id}`)
  },
  imprimirPedido(id) {
    return api.post(`/pedidos/${id}/imprimir`)
  },
  asignarPedido(pedidoId, usuarioId) {
    return api.post(`/pedidos/${pedidoId}/asignar`, { id: usuarioId })
  },
  asignarPedidoVendedor(pedidoId) {
    return api.post(`/pedidos/${pedidoId}/asignarVendedor`)
  },
  updatePedidoItem(payload) {
    return api.patch(`/pedidos/items/${payload.id}`, payload)
  },
  entregarPedido(id) {
    return api.post(`/pedidos/${id}/despachar`)
  },
  updateStockPedido(id) {
    return api.patch(`/pedidos/${id}/stock`)
  },
  confirmarEntregaParcial(itemId) {
    return api.patch(`/pedidos/items/${itemId}/confirmar-entrega`)
  },
  pausarEjecucionPedido(id) {
    return api.post(`/pedidos/${id}/pausar`)
  },
  despacharAsync(pedidoId) {
    return api.post(`/pedidos/${pedidoId}/despachar-async`)
  },
  reintentarDespacho(pedidoId) {
    return api.post(`/pedidos/${pedidoId}/reintentar-despacho`)
  }
}

export default methods
